{
  "name": "impekkable-stock",
  "version": "1.5.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start 4204": "ng serve --port 4204",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.0.0",
    "@angular/common": "^19.0.0",
    "@angular/compiler": "^19.0.0",
    "@angular/core": "^19.0.0",
    "@angular/forms": "^19.0.0",
    "@angular/platform-browser": "^19.0.0",
    "@angular/platform-browser-dynamic": "^19.0.0",
    "@angular/router": "^19.0.0",
    "@maskito/angular": "^3.1.1",
    "@maskito/core": "^3.1.1",
    "@maskito/phone": "^3.1.1",
    "@ng-bootstrap/ng-bootstrap": "^18.0.0",
    "@popperjs/core": "^2.11.8",
    "bootstrap": "^5.3.3",
    "jwt-decode": "^4.0.0",
    "libphonenumber-js": "^1.11.12",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.0.5",
    "@angular/cli": "^19.0.5",
    "@angular/compiler-cli": "^19.0.0",
    "@angular/localize": "^19.0.0",
    "@types/googlemaps": "^3.43.3",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.4.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.6.2"
  },
  "volta": {
    "node": "20.14.0"
  }
}
